import { Box, InputAdornment, makeStyles, SvgIcon, TextField } from "@material-ui/core";
import FormGroup from "@material-ui/core/FormGroup";
import React from "react";
import { Search as SearchIcon } from "react-feather";

const useStyles = makeStyles((theme) => ({
	root: {},
	importButton: {
		marginRight: theme.spacing(1),
	},
	exportButton: {
		marginRight: theme.spacing(1),
	},
	SearchWithToggle: {
		marginRight: theme.spacing(2),
	}
}));

const Toolbar = ({ on_search }) => {
	const classes = useStyles();

	return (
		<div >

			<Box mt={3} display="flex" flexDriection="row">
				<FormGroup row>
					<TextField
						style={{
							width: "400px",
						}}
						className={classes.SearchWithToggle}
						InputProps={{
							startAdornment: (
								<InputAdornment position="start">
									<SvgIcon fontSize="small" color="action">
										<SearchIcon />
									</SvgIcon>
								</InputAdornment>
							),
						}}
						onChange={on_search}
						placeholder="Search Vehicles"
						variant="outlined"
					/>
				</FormGroup>
			</Box>
		</div>
	);
};


export default Toolbar;
